import { render, staticRenderFns } from "./BarProductCard.vue?vue&type=template&id=7658df8b&scoped=true&"
import script from "./BarProductCard.vue?vue&type=script&lang=js&"
export * from "./BarProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7658df8b",
  null
  
)

export default component.exports